<i18n>
{
    "et": {
        "Select language": "Vali keel"
    }
}
</i18n>
<template>
  <div class="app-language-selector">
    <v-menu bottom offset-y left v-if="currentItem">
      <template v-slot:activator="{ on }">
        <v-btn rounded aria-set v-bind="{ icon: true, ...$attrs }" v-on="on" text>
          <country-flag :flag="currentItem.flag" />
          <slot v-bind="currentItem" name="default"></slot>
        </v-btn>
      </template>
      <v-list>
        <v-list-item
          :id="'list-item-' + key"
          v-for="(item, key) in items"
          :key="key"
          @click="onItemClick(key)"
          :class="key === currentLocale ? 'v-item--active v-list-item--active' : 'is-inactive'"
        >
          <v-list-item-title class="text--uppercase">
            <country-flag :flag="item.flag" left />
            {{ item.native }}
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
import CountryFlag from "@/_shared/components/localization/CountryFlag.vue";
import { fetchAndUpdateLanguage } from "@/landing/plugins/i18n";
import router from "@/landing/router";
import { fullDomain } from "@/_shared/lib/meta/url-locale";

export default {
  components: {
    CountryFlag,
  },

  computed: {
    items() {
      return this.$store.state.lang.options;
    },
    currentLocale() {
      return this.$i18n.locale;
    },
    currentItem() {
      return this.items[this.currentLocale];
    },
  },

  data() {
    return {
      shouldRedirectToLocaleUrl: true,
    };
  },

  methods: {
    async onItemClick(key) {
      await this.axios.post("/api/translations/set/" + key);
      if (key === this.$i18n.locale) return;

      if (this.shouldRedirectToLocaleUrl) {
        /** This will set user language (if authenticated) */

        /** Redirecting to localized url will set session locale and do redirect */
        window.location.replace(fullDomain + key + this.$route.fullPath);
      } else {
        /*
        This will not redirect url but updates state with new loalized content.
        For seo reasons we dont need this anymore probably, but let's keep it here for future reference.
        */
        await fetchAndUpdateLanguage(key, this.$store, this.$vuetify);
      }
    },
  },
};
</script>
